
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BoListPanel } from 'bonomo/dist';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import BusinessClientNav from '@/components/businessClient/widget/BusinessClientNav.vue';
import { BetterDataTableHeader } from '@/model/betterVuetifyInterfaces';
import { IBusinessClient } from '@/model/BusinessClient/businessClientInterfaces';
import axios from 'axios';
import { settings } from '@/plugins/settings';

const clientModule = namespace('clientModule');

@Component({
  name: 'BusinessClientCommunities',
  components: { BoListPanel, PaginationBar, BusinessClientNav },
})
export default class BusinessClientCommunities extends Vue {
  @Prop()
  protected clientId!: number;

  @clientModule.Getter('businessClient')
  protected client!: IBusinessClient;

  @clientModule.Action('fetchBusinessClient')
  private fetchClient!: (id: number) => Promise<any>;

  private communityList: any[] = [];
  private currentPage: number = 1;
  private lastPage: number = 1;
  private total: number = 0;
  private perPage: number = 15;
  private selectedPerPage: number = 15;
  private loading: boolean = false;

  readonly perPageOptions: number[] = [15, 30, 50, 100];

  get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('common.id') as string, align: 'start', sortable: true, value: 'id' },
      { text: this.$t('common.name') as string, align: 'start', sortable: true, value: 'name' },
      { text: this.$t('communities.fields.slug') as string, align: 'start', sortable: true, value: 'slug' },
      { text: this.$t('common.status') as string, align: 'start', sortable: false, value: 'status' },
      { text: this.$t('communities.fields.channel') as string, align: 'start', sortable: false, value: 'channel_name' },
      { text: this.$t('communities.fields.invitationCode') as string, align: 'start', sortable: false, value: 'invitation_code' },
      { text: this.$t('communities.fields.locationCity') as string, align: 'start', sortable: false, value: 'location_city' },
      { text: '', value: 'detailButton', sortable: false },
    ];
  }

  loadData() {
    if (!this.client || !this.client.id) {
      this.fetchClient(this.clientId);
    }
    this.fetchPage(1);
  }

  mounted() {
    this.loadData();
  }

  private async fetchPage(page: number) {
    this.loading = true;
    try {
      const response = await axios.get(
        settings.endpoint + 'business-clients/' + this.clientId + '/communities',
        { params: { page, per_page: this.selectedPerPage } }
      );
      const payload = response.data && response.data.data;
      this.communityList = Array.isArray(payload) ? payload : (Array.isArray(payload && payload.data) ? payload.data : []);
      const meta = payload && !Array.isArray(payload) ? payload : (response.data && response.data.data);
      if (meta && meta.current_page) {
        this.currentPage = meta.current_page;
        this.lastPage = meta.last_page || 1;
        this.total = meta.total || 0;
        this.perPage = meta.per_page || this.selectedPerPage;
      }
    } finally {
      this.loading = false;
    }
  }

  onPageChange(page: number) {
    this.fetchPage(page);
  }

  onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.fetchPage(1);
  }
}
